'use strict';

const FavoriteModel = require('bunsen/models/identity/Favorite');
const deviceTypeHelper = require('../../../global/utils/deviceTypeHelper');
const {isPageType, pageTypes: {PAGE_TYPE}} = require('dibs-buyer-layout/src/entries/index');
const calloutHelper = require('../../../components/Callout/calloutHelper');
const forceFavorite = require('../../../favorites/forceFavorite');
const calloutActions = require('../../../components/Callout/calloutActions');

/**
 * Checks condition for follow dealer callout.
 * Opens callout if condition is satisfied.
 * Condition - dealer page.
 *
 * @return {Promise}
 */
const followDealerCalloutRule = function followDealerCalloutRule({ context }) {
    const { TYPE_DEALER } = FavoriteModel;
    const type = calloutHelper.CALLOUT_TYPE_FOLLOW_DEALER;
    const isDealerPage = isPageType(PAGE_TYPE.DEALER);
    const favoriteForced = forceFavorite.isTypeForced(forceFavorite.TYPE_DEALER);
    const canShowCallout = calloutHelper.canShowCallout({ type });
    const isMobile = deviceTypeHelper.isMobileOrTablet();

    if (isMobile || !canShowCallout || favoriteForced || !isDealerPage) {
        return Promise.resolve();
    }

    return calloutHelper
        .hasUserFavorites({ type, context, favoriteType: TYPE_DEALER })
        .then(hasFavorites => {
            if (!hasFavorites) {
                context.executeAction(calloutActions.openCallout, { type });
                return { success: true, type };
            }

            return { success: false, type };
        });
};

module.exports = followDealerCalloutRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/followDealerCalloutRule.es.js